/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

export function initReadMore() {
  const toggles = document.querySelectorAll<HTMLButtonElement>(
    '.read-more__toggle',
  )

  toggles.forEach((toggle) => {
    if (toggle.dataset.hydrated) return
    toggle.dataset.hydrated = 'true'
    const iconToggle = toggle.querySelector('.icon__toggle')
    const labelToggle = toggle.querySelector('.label__toggle')

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true'

      if (expanded) {
        iconToggle?.dispatchEvent(new CustomEvent('toggle-default'))
        labelToggle?.dispatchEvent(new CustomEvent('toggle-default'))
        toggle.setAttribute('aria-expanded', 'false')
      } else {
        iconToggle?.dispatchEvent(new CustomEvent('toggle-toggle'))
        labelToggle?.dispatchEvent(new CustomEvent('toggle-toggle'))
        toggle.setAttribute('aria-expanded', 'true')
      }
    })
  })
}
